export const toDescriptor = vehicle => {
  if (!!vehicle.state && !!vehicle.license) {
    return `${vehicle.state} · ${vehicle.license}`;
  } else if (!!vehicle.vin) {
    return `VIN·${vehicle.vin.slice(0, 7)}${vehicle.vin.length > 7 ? "…" : ""}`;
  } else {
    return "Unknown";
  }
};
export const toMakeModel = ({
  year,
  make,
  model,
  color
}) => [year, color, make, model].filter(Boolean).join(" ");
